import React from 'react';
import HeroSlide from './HeroSlide/HeroSlide';
import JobPreperation from './JobPreperation/JobPreperation';
import LiveCourse from './LiveCourse/LiveCourse';
import MySelf from './MySelf/MySelf';
import OurGain from './OurGain/OurGain';
import Review from './Review/Review';

const HomePages = () => {
    return (
        <div className='container-fluid p-0 m-0'>
            <HeroSlide />
            <MySelf />
            <LiveCourse />
            <OurGain />
            <JobPreperation />
            <Review />
        </div>
    );
};

export default HomePages;